import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import publicApi from '../services/public.api';
import { useLocation } from '../context/LocationContext';

const FALLBACK_CATEGORIES = [
    { id: 1, name: 'Khalie', image: 'assets/images/thumbs/feature-img1.png', products_count: 0 },
    { id: 2, name: 'Gâteaux Traditionnels', image: 'assets/images/thumbs/feature-img2.png', products_count: 0 },
    { id: 3, name: 'Prestige', image: 'assets/images/thumbs/feature-img3.png', products_count: 0 },
];

const FeatureOne = () => {
    // State for dynamic categories
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const { priceRegion } = useLocation();

    // Fetch categories from API
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await publicApi.getCategories(priceRegion);
                if (response.success && response.data.length > 0) {
                    setCategories(response.data);
                } else {
                    setCategories(FALLBACK_CATEGORIES);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
                setCategories(FALLBACK_CATEGORIES);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, [priceRegion]);

    // Get image URL - handles both API images and static images
    const getImageUrl = (category) => {
        if (category.image && category.image.startsWith('categories/')) {
            return publicApi.getImageUrl(category.image);
        }
        // Fallback to static image if no API image
        return category.image || 'assets/images/thumbs/feature-img1.png';
    };

    // Format products count
    const formatProductsCount = (count) => {
        if (count >= 100) return '100+ Products';
        if (count > 0) return `${count} Product${count > 1 ? 's' : ''}`;
        return '0 Products';
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1699,
                settings: {
                    slidesToShow: 9,
                },
            },
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 8,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 359,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };
    return (
        <div className="feature" id="featureSection">
            <div className="container container-lg">
                <div className="position-relative arrow-center">
                    <div className="flex-align">
                        <button
                            type="button"
                            id="feature-item-wrapper-prev"
                            className="slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                        >
                            <i className="ph ph-caret-left" />
                        </button>
                        <button
                            type="button"
                            id="feature-item-wrapper-next"
                            className="slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                        >
                            <i className="ph ph-caret-right" />
                        </button>
                    </div>
                    <div className="feature-item-wrapper">
                        {loading ? (
                            // Loading skeleton - same design
                            <div className="d-flex justify-content-center gap-3">
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <div key={i} className="feature-item text-center">
                                        <div className="feature-item__thumb rounded-circle bg-gray-100" style={{ width: 80, height: 80 }}></div>
                                        <div className="feature-item__content mt-16">
                                            <div className="bg-gray-100 rounded" style={{ width: 60, height: 16, margin: '0 auto' }}></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Slider {...settings}>
                                {categories.map((category) => (
                                    <div key={category.id} className="feature-item text-center">
                                        <div className="feature-item__thumb rounded-circle">
                                            <Link to={`/shop?category=${category.id}`} className="w-100 h-100 flex-center">
                                                <img src={getImageUrl(category)} alt={category.name} />
                                            </Link>
                                        </div>
                                        <div className="feature-item__content mt-16">
                                            <h6 className="text-lg mb-8">
                                                <Link to={`/shop?category=${category.id}`} className="text-inherit">
                                                    {category.name}
                                                </Link>
                                            </h6>
                                            <span className="text-sm text-gray-400">{formatProductsCount(category.products_count)}</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FeatureOne